import { z } from 'zod';

// What the storefront's search panel asks for while a shopper types, and what it is answered with: a few
// products with their picture and price, and the collections and pages whose names match. The answer is
// parsed on arrival like any other read, so a field the server stops sending is a gap, not a crash.

/** The words typed so far; a search panel never asks with nothing in it. */
export const StoreSuggestQuerySchema = z.object({
  q: z.string().trim().min(1).max(100)
});

/** One product offered as the shopper types: enough to draw its row and link to it. */
export const SuggestedProductSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  image: z.string().nullable(),
  price: z.number(),
  compareAtPrice: z.number().nullable()
});

/** One collection or page whose name matches: its name and where it is. */
export const SuggestedLinkSchema = z.object({ title: z.string(), slug: z.string() });

/** Everything the panel shows for the words typed. */
export const StoreSuggestionsSchema = z.object({
  products: z.array(SuggestedProductSchema),
  collections: z.array(SuggestedLinkSchema),
  pages: z.array(SuggestedLinkSchema)
});

export type StoreSuggestQuery = z.infer<typeof StoreSuggestQuerySchema>;
export type SuggestedProduct = z.infer<typeof SuggestedProductSchema>;
export type SuggestedLink = z.infer<typeof SuggestedLinkSchema>;
export type StoreSuggestionsDto = z.infer<typeof StoreSuggestionsSchema>;
